import React from "react";

type InfoDisplayProps = {
  label: React.ReactNode;
  value: string | undefined;
  optionNode?: React.ReactNode;
};

const InfoDisplay: React.FC<InfoDisplayProps> = ({ label, value, optionNode }) => (
  <div className="contact-box__item">
    <label className="contact-box__ttl">
      <span>{label}</span>
    </label>
    <div className="contact-box__ct">
      <p className="contact-box__desc">{value}</p>
      {optionNode}
    </div>
  </div>
);

export default InfoDisplay;